import { RouteRecordRaw } from 'vue-router';

const holidayRoutes: Array<RouteRecordRaw> = [
  {
    path: '',
    component: () =>
      import('@/app/holiday/components/holiday-index-component.vue'),
    children: [
      {
        path: 'holiday/calendar',
        component: () =>
          import(
            '@/app/holiday/components/calendar/holiday-calendar-component.vue'
          ),
        name: 'app.holiday.calendar',
      },
      {
        path: 'holiday/holidays',
        component: () =>
          import(
            '@/app/holiday/components/holidays/holiday-holidays-component.vue'
          ),
        name: 'app.holiday.holidays',
      },
      {
        path: 'holiday/approve-requests',
        component: () =>
          import(
            '@/app/holiday/components/approve-requests/holiday-approve-requests-component.vue'
          ),
        name: 'app.holiday.approve_requests',
      },
    ],
  },
];

export default holidayRoutes;
